import { Tooltip, Typography } from 'antd';
import React from 'react';
import { Locale } from '../../../../localization/LocalizationKeys';
import { siteFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import { SiteCriteriaOrder } from '../../../../gql/typings';
import { TableFieldReturnedRecordPageType } from '../../search_old/types';


export const siteVisitAddressLine2FieldConfig = siteFieldConfig(
  'visitAddressLine2',
  [
    'visitAddress.id',
    'visitAddress.addressLine2',
  ],
  ({ localization }) => ({
    sorting: {
      ascend: SiteCriteriaOrder.VISIT_STREET_ASC,
      descend: SiteCriteriaOrder.VISIT_STREET_DESC,
    },
    title: localization.formatMessage(Locale.Attribute.Visit_address_line_2),
    // className: 'apb-antd-table-column-width-no-wrap',
    render: (record, { isViewingFromPage }) => {
      const addressLine2 = record.visitAddress?.addressLine2;
      return (<Typography.Paragraph
        style={{ marginBottom: 0 }}
        ellipsis={{ rows: isViewingFromPage === TableFieldReturnedRecordPageType.DETAIL_PAGE ? 2 : 1 }}
      >
        <Tooltip placement='left' title={addressLine2}>{addressLine2}</Tooltip>
      </Typography.Paragraph>);
    },
  })
);
